import { render, staticRenderFns } from "./ArticleImageComponent.vue?vue&type=template&id=9b877d50&"
import script from "./ArticleImageComponent.vue?vue&type=script&lang=js&"
export * from "./ArticleImageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports